import React from 'react'
import { DateInput } from './Form'
import { DumbField } from '../Field'

export default class DateRange extends React.Component {
	setValue = (value, key) => {
		this.props.onChange({ ...this.props.value, [key]: value })
	}
	onBlur = () => {
		if (this.props.onBlur) this.props.onBlur(this.props.value)
	  }
	  onButtonClicked = (value, key) => {
		if (this.props.onButtonClicked) {
		  this.props.onButtonClicked({ ...this.props.value, [key]: value })
		}
	  }
	  render() {
		const {
			label = "",
		  startLabel,
		  endLabel,
		  value,
		  isFirst,
		  validityClass,
		  stacked,
		  todayButton,
		  onPickerOpened,
		  onPickerClosed,
		  fieldId,
		  disabled,
			tabIndex
		} = this.props
		return (
		  <div className="row">
			<div className={stacked ? 'col-12' : 'col-sm-6 col-md-6 col-lg-5'}>
			  <DumbField label={startLabel} fieldId={`date-${fieldId}s`}>
				<DateInput
				  validityClass={validityClass}
				  fieldId={`${fieldId}s`}
				  name="start"
				  value={value.start}
				  onChange={(value) => {
					this.setValue(value, 'start')
				  }}
				  onBlur={this.onBlur}
				  disabled={disabled}
				  isFirst={isFirst}
				  maxDate={value.end}
				  todayButton={todayButton}
				  onButtonClicked={(value) => {
					this.onButtonClicked(value, 'start')
				  }}
				  onPickerOpened={onPickerOpened}
				  onPickerClosed={onPickerClosed}
					tabIndex={tabIndex}
					ariaLabel={`${label}: ${startLabel}`}
				/>
			  </DumbField>
			</div>
			<div className={stacked ? 'col-12' : 'col-sm-6 col-md-6 col-lg-5'}>
			  <DumbField label={endLabel} fieldId={`date-${fieldId}e`}>
				<DateInput
				  validityClass={validityClass}
				  fieldId={`${fieldId}e`}
				  name="end"
				  value={value.end}
				  disabled={disabled}
				  onChange={(value) => {
					this.setValue(value, 'end')
				  }}
				  onBlur={this.onBlur}
				  todayButton={todayButton}
				  minDate={value.start}
				  onButtonClicked={(value) => {
					this.onButtonClicked(value, 'end')
				  }}
				  onPickerOpened={onPickerOpened}
				  onPickerClosed={onPickerClosed}
					tabIndex={tabIndex}
					ariaLabel={`${label}: ${endLabel}`}
				/>

					</DumbField>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/DateRange.js